<script>
import WebcamRecorderIncreaseScaleButton from './webcam-recorder-increase-scale-button.vue'
import WebcamRecorderDecreaseScaleButton from './webcam-recorder-decrease-scale-button.vue'

export default {
  name: 'WebcamRecorderTransformControls',
  components: { WebcamRecorderDecreaseScaleButton, WebcamRecorderIncreaseScaleButton }
}
</script>

<template>
  <div class="btn-group p-1">
    <webcam-recorder-increase-scale-button />
    <webcam-recorder-decrease-scale-button />
  </div>
</template>
